import React from 'react';
import { connect } from 'react-redux';
import Input from 'widgets/Input';
import Button from 'widgets/Button';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import colors from 'assets/styles/jsVariables/colors';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import './DeleteConfirmationModal.scss';

const styles = {
  deleteConfirmButtonStyle: {
    '&:hover': {
      background: `${colors.darkerCyan} !important`,
      boxShadow: 'rgba(176, 176, 176, 0.5) 0px 2px 5px 1px'
    },
    height: '45px',
    width: '166px',
  },
  deleteConfirmButtonLabelStyle: {
    fontFamily: 'museosansrounded_100',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: '16px'
  },
  inputStyle: {
    border: `2px solid ${colors.lighterCyan}`,
    borderRadius: '6px',
    padding: '0px 10px',
    marginBottom: '10px',
    height: '44px'
  }
};
/**
 * A modal dialog can only be closed by selecting one of the actions.
 */
class DeleteConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteDisable: true,
      emailErrorMsg: ''
    };
  }

  handleInput = (event) => {
    const { value } = event.target;
    if (value.toLowerCase() === this.props.email) {
      this.setState({ deleteDisable: false, emailErrorMsg: '' });
    } else if (!value.trim()) {
      this.setState({ deleteDisable: true, emailErrorMsg: '' });
    } else {
      this.setState({ deleteDisable: true, emailErrorMsg: <FormattedMessage id="views.dataPolicy.deleteConfirmationModal.emailErrorText" /> });
    }
  }

  handleCancel = () => {
    this.props.handleClose();
    this.setState({ deleteDisable: true });
  }

  render() {
    const { deleteDisable, emailErrorMsg } = this.state;
    const {
      isModalOpen,
      handleDelete,
      handleClose,
      intl
    } = this.props;

    const paperStyle = {
      maxWidth: 400,
      width: '80%',
      borderRadius: '10px',
    };

    return (
      <Modal
        open={isModalOpen}
        id="DataPolicyDeleteConfirmation"
        title={<FormattedMessage id="views.dataPolicy.deleteConfirmationModal.title" />}
        titleContainerStyle={{
          fontSize: '22px',
          paddingLeft: '24px',
          color: colors.darkGrey,
          lineHeight: '20px',
          fontFamily: 'museosansrounded_500'
        }}
        paperStyle={paperStyle}
        childrenStyle={{
          paddingLeft: '26px',
          paddingBottom: '10px',
          paddingRight: '65px',
          marginRight: '0px',
          border: '0px'
        }}
        iconName="x-icon-white"
        iconFill="#c6c6c6"
        toggleModal={handleClose}
        repositionOnUpdate={false}
        modal
        actions={[
          <div key="confirmButton" style={{ margin: '15px' }}>
            <Button
              id="DeleteConfirmButton"
              cssStyles={{
                root: styles.deleteConfirmButtonStyle,
                label: styles.deleteConfirmButtonLabelStyle,
              }}
              style={{
                backgroundColor: deleteDisable ? colors.disabledLighterCyan : colors.lighterCyan
              }}
              disabled={deleteDisable}
              onClick={handleDelete}
            >
              <FormattedMessage
                id="views.dataPolicy.deleteConfirmationModal.confirmButton"
              />
            </Button>
          </div>
        ]}
      >
        <div style={{ fontSize: '14px', color: colors.mediumGrey, lineHeight: '18px' }}>
          <FormattedHTMLMessage
            id="views.dataPolicy.deleteConfirmationModal.description"
          />
          <div style={{ paddingTop: '20px' }}>
            <Input
              name="email"
              className={`DeleteConfirmationModal__Input ${emailErrorMsg && 'DeleteConfirmationModal__Input__ErrorBorder'}`}
              onChange={this.handleInput}
              placeholder={intl.formatMessage({ id: 'views.dataPolicy.deleteConfirmationModal.emailPlaceholder' })}
              style={{ width: '100%', maxWidth: '297px' }}
              cssStyles={{
                input: styles.inputStyle
              }}
              autoFocus
            />
            <div style={{ color: colors.red }}>{emailErrorMsg}</div>
          </div>
        </div>
      </Modal>
    );
  }
}

DeleteConfirmationModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired
};

const mapStateToProps = ({ auth }) => ({
  email: auth.info.user.email
});

export default connect(mapStateToProps, null)(injectIntl(DeleteConfirmationModal));



// WEBPACK FOOTER //
// ./src/views/DataPolicy/DeleteConfirmationModal.jsx